import React from "react";

import * as S from "./Ruler.styles";

const Ruler = props => <S.Layout {...props} />;

export default React.memo(Ruler);
